var exports = {
  "container": "x43cbe9c2--239dd3--container",
  "compact-top": "x43cbe9c2--239dd3--compact-top",
  "title": "x43cbe9c2--239dd3--title",
  "phone": "x43cbe9c2--239dd3--phone",
};

module.exports = exports;
